import router from './router'
import store from './store'

// 路由拦截
router.beforeEach(async(to, from, next)=>{
  const accessRoutes = await store.dispatch('permission/generateRoutes')
  if(to.meta.Auth){
    if(store.getters.isLogin){
      next();
    } else{
      next({
        path:'/login'
      })
    }
  } else {
    next()
  }
})


// WEBPACK FOOTER //
// ./src/permissions.js